import React from "react";
import Header from "../Header";
import Footer from "../Footer";
// import {ReactTitle} from 'react-meta-tags';
import {Helmet} from "react-helmet";

import { Link } from "react-router-dom";
import "./about.css";
import AudioPlayer from "../Audio/AudioPlayer";
import Slider from "../Slider/Slider";

const About = (props) => {
  const img1 = "/assets/wp-content/uploads/2018/12/ramdev-gallery3.jpg";
  const metaabout = {
    title: "About Ramapir",
    description: "About Ramapir",
    meta: {
      name: { keywords: "viewport" },
      content: "width=device-width, initial-scale=1",
    },
  };
  return (
    <>
          
      <Helmet>
            <title>Ramapir | About </title>
            <meta name="keywords" content="શ્રી રામદેવજીએ 1442માં ભાદ્રપદ શુક્લ એકાદશીના રોજ રાજસ્થાનમાં રામદેવરા (પોખરણથી 10 કિમી) ખાતે 33 વર્ષની વયે સમાધિ લીધી હતી. રામદેવનું વિશ્રામ સ્થાન ધરાવતું મંદિર સંકુલ રાજસ્થાનમાં રામદેવરા (પોખરણથી 10 કિમી) ખાતે આવેલું છે" />
        </Helmet>
      <Header />
      <div
        data-elementor-type="cpt_layouts"
        data-elementor-id="46"
        className="elementor elementor-46"
      >
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-52ebb12 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="52ebb12"
          data-element_type="section"
          data-settings='{"background_background":"classic"}'
          style={{ height: "30rem", marginBottom: "5rem" }}
        >
          <div className="elementor-background-overlay"></div>
          <div className="elementor-container elementor-column-gap-extended">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ae9d67e sc_inner_width_none sc_layouts_column_icons_position_left"
              data-id="ae9d67e"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <section
                  className="elementor-section elementor-inner-section elementor-element elementor-element-fcf91b3 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="fcf91b3"
                  data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-93dfaf4 sc_inner_width_none sc_layouts_column_icons_position_left"
                      data-id="93dfaf4"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="sc_layouts_item elementor-element elementor-element-847c2c5 sc_fly_static elementor-widget elementor-widget-spacer"
                          data-id="847c2c5"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                          style={{ height: "8rem" }}
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner"></div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="sc_layouts_item elementor-element elementor-element-8fe49e3 sc_fly_static elementor-widget elementor-widget-trx_sc_layouts_title"
                          data-id="8fe49e3"
                          data-element_type="widget"
                          data-widget_type="trx_sc_layouts_title.default"
                        >
                          <div className="elementor-widget-container">
                            <div
                              id="trx_sc_layouts_title_515615674"
                              className="sc_layouts_title sc_align_center with_content without_image without_tint"
                            >
                              <div className="sc_layouts_title_content">
                                <div className="sc_layouts_title_title">
                                  {" "}
                                  {/* <h1 className="sc_layouts_title_caption">
                                    Temple
                                  </h1> */}
                                </div>
                                <div className="sc_layouts_title_breadcrumbs">
                                  <div className="breadcrumbs">
                                    {/* <Link
                                      to="/"
                                      className="breadcrumbs_item home"
                                    >Home
                                    </Link> */}
                                    {/* <span className="breadcrumbs_item current">
                                      Temple
                                      
                                                                          </span> */}
                                  </div>
                                </div>
                              </div>
                            </div>{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div className="page_content_wrap">
        <div className="content_wrap">
          <div className="content">
            <article
              id="post-407"
              className="post_item_single post_type_page post-407 page type-page status-publish hentry"
            >
              <div className="post_content entry-content">
                <div
                  data-elementor-type="wp-post"
                  data-elementor-id="407"
                  className="elementor elementor-407"
                >
                  <section
                    className="elementor-section elementor-top-section elementor-element elementor-element-159258c elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="159258c"
                    data-element_type="section"
                  >
                    <div className="elementor-container elementor-column-gap-extended">
                      <div
                        className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-fe5f5b1 sc_inner_width_none sc_layouts_column_icons_position_left"
                        data-id="fe5f5b1"
                        data-element_type="column"
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div
                            className="elementor-element elementor-element-d8adc01 sc_fly_static elementor-widget elementor-widget-spacer"
                            data-id="d8adc01"
                            data-element_type="widget"
                            data-widget_type="spacer.default"
                          >
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  <section
                    className="elementor-section elementor-top-section elementor-element elementor-element-a9d1228 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="a9d1228"
                    data-element_type="section"
                  >
                    <div className="elementor-container elementor-column-gap-extended">
                      <div
                        className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-78b092d sc_inner_width_none sc_layouts_column_icons_position_left  our_core_mission_section"
                        data-id="78b092d"
                        data-element_type="column"
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div
                            className="elementor-element elementor-element-c289823 sc_fly_static elementor-widget elementor-widget-trx_sc_title"
                            data-id="c289823"
                            data-element_type="widget"
                            data-widget_type="trx_sc_title.default"
                          >
                            <div className="elementor-widget-container">
                              <div
                                id="trx_sc_title_1039143425"
                                className="sc_title sc_title_default"
                              >
                                <span className="sc_item_subtitle sc_title_subtitle sc_item_subtitle_above sc_item_title_style_default">
                                  શ્રી રામાપીર વિશે
                                </span>
                                <h1 className="sc_item_title sc_title_title sc_item_title_style_default sc_item_title_tag">
                                  <span className="sc_item_title_text">
                                    બાબા રામદેવ અથવા રામદેવજી, અથવા રામદેવ પીર, રામશા પીર (1352-1385 એડી; .S. 1409-1442)

                                  </span>
                                </h1>
                              </div>{" "}
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-814de7a sc_fly_static elementor-widget elementor-widget-spacer"
                            data-id="814de7a"
                            data-element_type="widget"
                            data-widget_type="spacer.default"
                          >
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner"></div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-57702e5 sc_fly_static elementor-widget elementor-widget-heading"
                            data-id="57702e5"
                            data-element_type="widget"
                            data-widget_type="heading.default"
                          >
                            <div className="elementor-widget-container">
                              <h4 className="elementor-heading-title elementor-size-default about-content">
                                રામદેવરામાં સમાધિ અને મુખ્ય મંદિર

                              </h4>{" "}
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-7c4b363 sc_fly_static elementor-widget elementor-widget-spacer"
                            data-id="7c4b363"
                            data-element_type="widget"
                            data-widget_type="spacer.default"
                          >
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner"></div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-a296948 sc_fly_static elementor-widget elementor-widget-text-editor"
                            data-id="a296948"
                            data-element_type="widget"
                            data-widget_type="text-editor.default"
                          >
                            <div className="elementor-widget-container">
                              <p>
                                શ્રી રામદેવજીએ 1442માં ભાદ્રપદ શુક્લ એકાદશીના રોજ રાજસ્થાનમાં રામદેવરા (પોખરણથી 10 કિમી) ખાતે 33 વર્ષની વયે સમાધિ લીધી હતી.
                                રામદેવનું વિશ્રામ સ્થાન ધરાવતું મંદિર સંકુલ રાજસ્થાનમાં રામદેવરા (પોખરણથી 10 કિમી) ખાતે આવેલું છે. મંદિરનું માળખું 1931માં બિકાનેરના મહારાજા ગંગા સિંહ દ્વારા રામદેવના અંતિમ વિશ્રામ સ્થાનની આસપાસ બાંધવામાં આવ્યું હતું.
                                રામદેવરા જોધપુરથી જેસલમેર માર્ગ પર પોખરણ નજીક જેસલમેરથી લગભગ 120 કિમી દૂર આવેલું છે. રામદેવરામાં બાબા રામદેવજીનું મંદિર આવેલું છે. વિશ્વભરમાંથી ભક્તો આખા વર્ષ દરમિયાન મંદિટની મુલાકાત લે છે. અહીં ઓગસ્ટ અને ફેબ્રુઆરી મહિનામાં રામદેવરાનો મેળો ભરાય છે અને ભારતભરમાંથી
                                મોટી સંખ્યામાં ભક્તો તેમાં હાજરી આપે છે.
                                રામદેવરા સ્ટેશનના નજીકના રેલ્વે સ્ટેશન દ્વારા મંદિર સુધી પહોંચી શકાય છે, NH1 એ સૌથી નજીકનો હાઇવે છે જે મંદિરથી ઉત્તર પશ્ચિમથી અને શહેરના ઉત્તર ભાગથી ચાલે છે.

                                આ સંકુલમાં ડાલીબાઈ જેવા તેમના શિષ્યો અને તેમના કેટલાક મુખ્ય શિષ્યોની સમાધિઓ પણ છે. સંકુલમાં મક્કાના પાંચ મુસ્લિમ પીરની કબરો પણ છે,
                                તેમાં પાણીના પગથિયાના કૂવા પણ છે, જેનું પાણી ભક્તો માને છે કે તે ઉપચાર શક્તિ ધરાવે છે

                              </p>{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-676adb1 sc_inner_width_none sc_layouts_column_icons_position_left"
                        data-id="676adb1"
                        data-element_type="column"
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div
                            className="elementor-element elementor-element-671ccdc sc_fly_static elementor-widget elementor-widget-image"
                            data-id="671ccdc"
                            data-element_type="widget"
                            data-widget_type="image.default"
                          >
                            <div className="elementor-widget-container">
                              <img
                                decoding="async"
                                src={img1}
                                alt="about img 1"
                                loading="lazy"
                                className="about-img"
                              // style={{ height: '420px', objectFit: 'inherit' }}
                              />{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  <div
                    className="elementor-element elementor-element-64de630 sc_fly_static elementor-widget elementor-widget-spacer"
                    data-id="64de630"
                    data-element_type="widget"
                    data-widget_type="spacer.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner"></div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-17d05f5 sc_fly_static elementor-widget elementor-widget-heading"
                    data-id="17d05f5"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <div className="elementor-widget-container">
                      <h4 className="elementor-heading-title elementor-size-default about-content">
                        શ્રી રામદેવજીના પ્રથમ મંદિરનો ઈતિહાસ
                      </h4>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-ddc2f39 sc_fly_static elementor-widget elementor-widget-spacer"
                    data-id="ddc2f39"
                    data-element_type="widget"
                    data-widget_type="spacer.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner"></div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-096ee3d sc_fly_static elementor-widget elementor-widget-text-editor"
                    data-id="096ee3d"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>
                        શ્રી રામ દેવજીનું પ્રથમ મંદિર 1859 માં બનાવવામાં આવ્યું હતું, 1459 સીઇમાં રામદેવ પીટના નિધન પછી
                        સાડા ત્રણ સદીઓ પછી. એક દંતકથા અનુસાર, ઠંડો અલ્લાહયારમાં એક હિંદુ વ્યક્તિએ પ્રતિજ્ઞા લીધી કે જો તેને સંતાન પ્રાપ્ત થશે, તો તે તાંડો અલ્લાહયારમાં રામા પીરનો મેળો (મેળો) ગોઠવશે. તેમની ઈચ્છા પૂરી થતાં તેઓ આજના રાજસ્થાન, ભારતના રામદેવરામાં આવેલા રામ પીટના મૂળ મંદિરમાંથી આજના પાકિસ્તાનમાં આવેલા ટંડો અલ્લાહયાર ખાતેથી એક માટીનો દીવો લાવ્યા અને અહીં મંદિર બનાવ્યું.
                        તેમના હાથમાં "ધજા (ધ્વજા)" (ધ્વજા) લઈને મેળામાં, તેઓ શહેરની બહાર બેસીને આખી રાત "ભજન" પાઠ કરે છે અને વહેલી સવારે 5:00 વાગ્યે તેઓ મંદિરમાં "ધજા (ધ્વજા)" ફટકાવે છે. ડ્રમ અને ટ્રમ્પેટના તાલે નૃત્ય. રામા પીરને શ્રદ્ધાંજલિ આપવા પુરુષો, મહિલાઓ અને બાળકો સહિત હજારો ભક્તો પગપાળા યાત્રા કરે છે. તેઓ ધ્વજ (ધ્વજા) લાવે છે જે મંદિરમાં લહેરાવવામાં આવે છે.
                      </p>{" "}
                    </div>
                  </div>

                  <div
                    className="elementor-element elementor-element-64de630 sc_fly_static elementor-widget elementor-widget-spacer"
                    data-id="64de630"
                    data-element_type="widget"
                    data-widget_type="spacer.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner"></div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-17d05f5 sc_fly_static elementor-widget elementor-widget-heading"
                    data-id="17d05f5"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <div className="elementor-widget-container">
                      <h4 className="elementor-heading-title elementor-size-default about-content">
                        ઐતિહાસિક મહત્વ
                      </h4>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-ddc2f39 sc_fly_static elementor-widget elementor-widget-spacer"
                    data-id="ddc2f39"
                    data-element_type="widget"
                    data-widget_type="spacer.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner"></div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-096ee3d sc_fly_static elementor-widget elementor-widget-text-editor"
                    data-id="096ee3d"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>
                        આ ગામમાં તંવર રાજપૂત અને સંત બાબા રામદેવજીએ 1459 એડીમાં 33 વર્ષની ઉંમરે સમાધિ લીધી હતી. તે એક રાજસ્થાની રાજા હતો જેણે 14મી સીમાં પોખરણ પર શાસન કર્યું હતું. તેને ભગવાન કૃષ્ણનો અવતાર માનવામાં આવતો હતો. હિન્દુ, મુસ્લિમ, જૈન અને શીખ તેમના અનુયાયીઓ છે. ગામનું નામ બાબા સંતના નામ પરથી રાખવામાં આવ્યું છે. 1931માં બિકાનેરના રાજા ગંગા સિંહ દ્વારા સમાધિની આસપાસ એક મંદિર બનાવવામાં આવ્યું હતું.
                        બાબા રામદેવ પાસે કેટલીક જાદુઈ, હોશિયાર શક્તિઓ છે જેણે તેમની ખ્યાતિ દૂર દૂર સુધી ફેલાવી છે. ધીમે ધીમે અને ધીરે ધીરે, તે તેની શક્તિઓ અને હોશિયાર લક્ષણો માટે ખૂબ જ લોકપ્રિય બન્યો. આ કારણે પાંચ સંતો મક્કાથી તેમની શક્તિઓનું પરીક્ષણ કરવા અને ચકાસવા અને સાક્ષી આપવા માટે પહોંચ્યા કે શું તેમના વિશે જાહેર કરવામાં આવ્યું હતું તે બધું સાચું છે. તમામ સંભવિત પરીક્ષા પછી જ્યારે તેઓને ખાતરી થઈ, ત્યારે તેઓએ ખરેખર તેમને શ્રદ્ધાંજલિ આપી. આ જ વિસ્તારમાં એક કૂવો પણ છે જે બાબા રામદેવે પોતે બનાવ્યો હોવાનું મનાય છે. સ્થાનિક ગ્રામજનો આ કુવાના પાણીને પવિત્ર અને પવિત્ર માને છે.
                        1931 માં, બિકાનેરના મહારાજાએ "સમાધિ" ની આસપાસ એક મંદિર બનાવ્યું. બાબા રામદેવ રાજસ્થાનના લોકદેવતા છે. તેમની જન્મજયંતિ બાબા રામદેવ જયંતિ તરીકે ઉજવવામાં આવે છે. ભાદ્રપદ મહિનાના શુક્લ પક્ષની બીજી તિથિ છે.
                        રાજા અજમલ (અજાયસિંહ)એ છઠ્ઠાન બારુ ગામના પમજી ભાટીની પુત્રી રાણી મીનાલદેવી સાથે લગ્ન કર્યાં. ઘણા વર્ષો સુધી, દંપતી નિઃસંતાન રહ્યા. રાજા દ્વારકા ગયા અને કૃષ્ણને તેમના જેવા સંતાનની ઈચ્છા વિશે વિનંતી કરી. તેમને બે પુત્રો હતા, વિરમદેવ અને નાના રામદેવ. રામદેવનો જન્મ વિ.સં.માં ભાદરવા શુક્લ દૂજના
                        રોજ થયો હતો. 1409 બાડમેર જિલ્લાના કાશ્મીરમાં રામદેરિયા અંડુ ખાતે.
                        બાબા રામદેવ ખૂબ જ મહેનતુ રાજા હતા જેમણે પોતાનું જીવન તેમના રાજ્યના લોકો માટે સમર્પિત કર્યું હતું. તેમણે તેમના લોકો માટે ઘણા કલ્યાણના પગલાં લીધા. તેમણે ગરીબ અને દલિત લોકોના ઉત્થાન માટે સખત મહેનત કરી. તેમણે સમાનતાનો ઉપદેશ આપ્યો. તેઓ હિંદુ ધર્મના પુનરુત્થાન કરનાર હોવા છતાં, તેમણે તમામ ધર્મના લોકો સાથે સમાન વર્તન કર્યું. તેમણે ભાદ્રપદ શુક્લ એકાદશીના રોજ 33 વર્ષની ઉંમરે સમાધિ લીધી.
                      </p>{" "}
                    </div>
                  </div>


                  <div
                    className="elementor-element elementor-element-64de630 sc_fly_static elementor-widget elementor-widget-spacer"
                    data-id="64de630"
                    data-element_type="widget"
                    data-widget_type="spacer.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner"></div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-17d05f5 sc_fly_static elementor-widget elementor-widget-heading"
                    data-id="17d05f5"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <div className="elementor-widget-container">
                      <h4 className="elementor-heading-title elementor-size-default about-content">
                        સાંસ્કૃતિક મહત્વ
                      </h4>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-ddc2f39 sc_fly_static elementor-widget elementor-widget-spacer"
                    data-id="ddc2f39"
                    data-element_type="widget"
                    data-widget_type="spacer.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner"></div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-096ee3d sc_fly_static elementor-widget elementor-widget-text-editor"
                    data-id="096ee3d"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>
                        બાબા રામદેવ જી ભારતમાં રાજસ્થાનના લોક-દેવતા છે. તેઓ 14મી સીના સંત હતા, જેમણે પોતાનું જીવન દલિત લોકોના ઉત્થાન માટે સમર્પિત કર્યું હતું. જ્યારે હિંદુઓ તેમને ભગવાન કૃષ્ણના અવતાર માને છે, મુસ્લિમો તેમને રામશાહ પીર અથવા રામા શાહ પીર તરીકે પૂજે છે. તેમની પાસે ચમત્કારિક શક્તિઓ હોવાનું કહેવાય છે, અને તેમની ખ્યાતિ દૂર દૂર સુધી પહોંચી હતી. દંતકથા કહે છે કે મક્કાથી પાંચ પીર રામદેવની શક્તિઓનું પરીક્ષણ કરવા આવ્યા હતા. રામદેવે પ્રારંભિક સ્વાગત કર્યાં બાદ તેમને તેમની સાથે લંચ કરવા વિનંતી કરી. પરંતુ પીરોએ આગ્રહ કર્યો કે તેઓ તેમના અંગત વાસણોમાં ખાય છે, મક્કામાં પડેલા છે, તેથી તેઓ તેમનું ભોજન કરી શકે છે. આના પર રામદેવ હસ્યા અને કહ્યું, "જુઓ તમારા વાસણો આવી રહ્યા છે, અને તેઓએ જોયું કે તેમના ખાવાના વાસણો મક્કાથી હવામાં ઉડતા હતા. તેમની ક્ષમતાઓ અને શક્તિઓની ખાતરી થયા પછી, તેઓએ તેમને શ્રદ્ધાંજલિ આપી અને તેમનું નામ રામા શાહ પીર રાખ્યું. તેમની શક્તિઓનું પરીક્ષણ કરવા આવેલા પાંચ પીર તેમની શક્તિઓથી એટલા પ્રભાવિત થયા કે તેઓએ તેમની સાથે રહેવાનું નક્કી કર્યું અને આજે આ પાંચેયની સમાધિઓ પણ રામદેવની સમાધિ પાસે છે.
                        રાજસ્થાનમાં, રામદેવ મેઘવાલ સમુદાયના મુખ્ય દેવતા છે, જેની પૂજા વેદવા પુનમ (ઑગસ્ટ - સપ્ટેમ્બર) દરમિયાન કરવામાં આવે છે. સમુદાયના ધાર્મિક નેતા, ગોકુલદાસ, તેમના 1982ના પુસ્તક મેઘવાલ ઇતહાસમાં દાવો કરે છે કે રામદેવ પોતે મેઘવાલ હતા, જે મેઘવાલ સમુદાયનો ઇતિહાસ રચે છે. જો કે, આ દાવો માત્ર મેઘવાલ સમુદાયે જ સ્વીકાર્યો છે. અન્ય સ્ત્રોતો, લોકકથાઓ અને હિન્દુ સમુદાય સામાન્ય રીતે રામદેવનો જન્મ
                        તંવર રાજપૂત સમુદાયમાં થયો હોવાનું માને છે.
                        રામદેવ ઉંચા હોય કે નીચા, અમીર હોય કે ગરીબ તમામ માનવીઓની સમાનતામાં માનતા હતા. તેમણે દલિત લોકોને તેમની ઇચ્છા પૂરી કરીને મદદ કરી. તેને ઘણીવાર ઘોડા પર દર્શાવવામાં આવે છે. તેમની પૂજા હિંદુ- મુસ્લિમ વિભાજન તેમજ જાતિના ભેદને પાર કરે છે. તેમના અનુયાયીઓ રાજસ્થાન, હરિયાણા, પંજાબ, ગુજરાત અને મધ્ય પ્ર દેશ, મુંબઈ, દિલ્હી અને પાકિસ્તાનના સિંધમાં પણ જાતિ-અવરોધને પાર કરીને ફેલાયેલા છે. તેમની યાદમાં અનેક રાજસ્થાની મેળાઓ યોજાય છે. ભારતના ઘણા રાજ્યોમાં તેમના નામના મંદિરો જોવા મળે
                        છે.
                      </p>{" "}
                    </div>
                  </div>


                  <div
                    className="elementor-element elementor-element-64de630 sc_fly_static elementor-widget elementor-widget-spacer"
                    data-id="64de630"
                    data-element_type="widget"
                    data-widget_type="spacer.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner"></div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-17d05f5 sc_fly_static elementor-widget elementor-widget-heading"
                    data-id="17d05f5"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <div className="elementor-widget-container">
                      <h4 className="elementor-heading-title elementor-size-default about-content">
                        આર્કિટેક્ચરલ સિગ્નિફ્રિકન્સ અને ફીચર્સ
                      </h4>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-ddc2f39 sc_fly_static elementor-widget elementor-widget-spacer"
                    data-id="ddc2f39"
                    data-element_type="widget"
                    data-widget_type="spacer.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner"></div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-096ee3d sc_fly_static elementor-widget elementor-widget-text-editor"
                    data-id="096ee3d"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>
                        રામદેવરાની સમાધિ પાસે ઉત્તર તરફથી એક જ એપ્રોચ રોડ છે જે બજાર વિસ્તારની મધ્યમાં આવેલા ઉત્તરના સૌથી મોટા દરવાજા કરણી દ્વારથી મુખ્ય પ્રવેશદ્વાર તરફ દોરી જાય છે. મુખ્ય સમાધિનો દરવાજો રસ્તાની બંને બાજુએ કિઓસ્કથી સજ્જ છે; કરણી દ્વારથી સમાધિના પ્રવેશદ્વાર સુધી ચાલવા માટેનો આનંદદાયક વિસ્તાર પૂરો પાડવા માટે આ મુખ્ય માર્ગ સંપૂર્ણપણે સ્ટીલ ટ્રસ અને GI શીટથી ઢંકાયેલો છે.
                        છબી 3 કરણી દ્વારથી રામદેવ જી સમાધિના મુખ્ય પ્રવેશદ્વાર સુધી છબી 4 સ્થાનિક લોકો દ્વારા સુંદર પરંપરાગત હસ્તકલા
                        આખું આંગણું સ્ટીલ ટ્રસ અને સ્ટીલ ગર્ડર્સ (PEB સ્ટ્રક્ચર) સાથે સપોર્ટેડ GI શીટથી ઢંકાયેલું છે, જેમાં એક ખૂંટો ફાઉન્ડેશન ધરાવતા કૉટિ બ્લોક સાથે બોલ્ટ કરવામાં આવે છે, કારણ કે સમગ્ર આંગણામાં રામદેવ બાબાના વંશજોની કબરો છે તેથી કોઈપણ પ્રકારના પાયા અથવા કોઈપણ માળખા માટે ખોદકામ પ્રતિબંધિત છે. . સમાધિ પરિસરમાં જાહેર જનતાના વ્યવસ્થિત પરિભ્રમણ માટે આંગણામાં સ્ટીલની પંક્તિઓ છે. આવું
                        પહેલું વર્ષ છે અને તેઓ માને છે કે તેનાથી ભક્તોનો રાહ જોવાનો સમય અડધાથી ઓછો થઈ જશે.
                        આંગણામાં એક સમયે લગભગ 8,000 લોકો ઊભા રહી શકે છે અને મુખ્ય પ્રવેશદ્વારથી સમાધિ સુધી ચાલવાનો સમય અગાઉ 6-7 કલાકની સરખામણીએ ઘટીને દોઢ કલાક થઈ ગયો છે. આંગણાની દક્ષિણમાં રામદેવ બાબાના પૌત્રોની કબરો છે, જે આરસના બનેલા 5 ફૂટ ઊંચા પ્લેટફોર્મ પર આરસથી બનેલી છત્રીથી ઢંકાયેલી છે.
                        સમાધિના મુખ્ય બિલ્ડિંગ બ્લોકમાં પાંચ પ્રવેશદ્વાર અને બહાર નીકળવાના દરવાજા છે અને સમગ્ર સમાધિ પરિસર "દિવ્યજ્યોતિ", "કોર્ટ", "હોલી વોટર" અને "સ્ટેપવેલ નામની પરચા બાવરી" જેવા અનેક પૂજા સ્થાનોથી ભરેલું છે. તેનો દક્ષિણ ભાગ સમાધિ પરિસરની બહારની સમાધિમાં રામસરોવરના નજારા સાથે સુંદર જાહેર વિસ્તાર છે.
                        રામદેવ બાબા (પરચા બાવરી) દ્વારા સ્ટેપ વેલ - જૂના સમયમાં રામદેવરા ગામમાં તે એક્માત્ર પાણીનો સ્ત્રોત
                        હતો.
                        જૂની સમાધિ ઈમારત પથ્થરની બનેલી છે જે પરિભ્રમણ પર પ્રાથમિક ધ્યાન સાથે આદર્શ ભૂમિતિનો ખૂબ જ સરળ લંબચોરસ બ્લૉક છે. સમાધિ ઈમારતમાં સુશોભિત કમાનો અને પથ્થરના થાંભલા સિવાય રાજસ્થાની સ્થાપત્યના આવા કોઈ સૌંદર્યલક્ષી સ્થાપત્ય તત્વો હાજર નથી.
                        સમાધિ બ્લોકની ચારે બાજુ નવો બાંધવામાં આવેલો ભાગ એ સ્થાનિક કલાકાર દ્વારા કરવામાં આવેલ
                        દિવાલો પર ચશ્માના સુંદર સુશોભન સાથેનો વિસ્તૃત કોરિડોર છે. કોરિડોરની ઉપરની ટોચમર્યાદા સ્ટીલ I-
                        સેક્શન બીમથી સપોર્ટેડ છે.
                        રામ સરોવર તાલાબ (પવિત્ર સ્નાન)
                        સમાધિની દક્ષિણમાં, રામ સરોવર (પવિત્ર સ્નાન) છે જે ધાર્મિક વિધિઓનો એક ભાગ છે. આ તળાવ પથ્થરથી બનેલા પગથિયાંથી ઘેરાયેલું છે. તળાવના પૂર્વ ભાગ પરની જમીન કબ્રસ્તાનો ધરાવે છે; જમીનનો ભાગ સંપૂર્ણપણે ખુલ્લો છે અને કોઈપણ માળખાથી રદબાતલ છે.


                      </p>{" "}
                    </div>
                  </div>

                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
      <div className="about_footer">
        <Footer />
        {/* <AudioPlayer state={props.state} onPlay={(isPlay) => this.setState({ isPlay }) } /> */}
        {/* <AudioPlayer state={props.state} onPlay={(isPlay) => this.setState({ isPlay }) } /> */}
        {/* <AudioPlayer state={props.state} onPlay={(isPlay) => this.setState({ isPlay }) } /> */}
        {/* <AudioPlayer state={props.state} onPlay={(isPlay) => this.setState({ isPlay }) } /> */}
        {/* <AudioPlayer state={props.state} onPlay={(isPlay) => this.setState({ isPlay }) } /> */}
      </div>
    </>
  );
};
export default About;
